import React from "react";
import { Routes, Route } from "react-router-dom";
import Signin from "../container/Login/Signin";
import SignUp from "../container/Login/SignUp/SignUp";
import ForgotPassword from "../container/Login/ForgotPassword/ForgotPassword";
import OTPVerify from "../container/Login/OTPVerify/OTPVerify";
import CreatePassword from "../container/Login/CreatePassword/CreatePassword";
import VerifyMobileNumber from "../container/Login/VerifyMobileNumber/VerifyMobileNumber";

const UnAuthenticationRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Signin />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/two-step-verification" element={<VerifyMobileNumber />} />
    </Routes>
  );
};

export default UnAuthenticationRoutes;
